import React from 'react';
// import { NavLink } from 'react-router-dom';

const Footer = () => {
    return (
        <>
            <section>
                <footer className="text-center text-lg-start bg-body-tertiary text-muted">

                    <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">

                        <div className="me-5 d-none d-lg-block">
                            <span>Get connected with us on social networks:</span>
                        </div>

                        <div>
                            {/* Facebook */}
                            <a href="https://www.facebook.com/share/16FjNPxKg5/" target="_blank" rel="noopener noreferrer">
                                <i className="fa-brands fa-facebook" style={{ color: "#1877F2", fontSize: "24px", margin: "0 10px" }}></i>
                            </a>

                            {/* Instagram */}
                            <a href="https://www.instagram.com/p/DGrBwZksfjC/?igsh=MWZpaTBsMHVvZjNlbA==" target="_blank" rel="noopener noreferrer">
                                <i className="fa-brands fa-instagram" style={{ color: "#E4405F", fontSize: "24px", margin: "0 10px" }}></i>
                            </a>

                            {/* Location */}
                            <a href="https://maps.app.goo.gl/QfgpuJAjHQoQsyg7A" target="_blank" rel="noopener noreferrer">
                                <i className="fa-solid fa-location-dot" style={{ color: "#FF5733", fontSize: "24px", margin: "0 10px" }}></i>
                            </a>

                            {/* YouTube */}
                            <a href="https://youtu.be/CJnLv5UyEfU?si=qQW6PgdkR46jmAez" target="_blank" rel="noopener noreferrer">
                                <i className="fa-brands fa-youtube" style={{ color: "#FF0000", fontSize: "24px", margin: "0 10px" }}></i>
                            </a>

                            {/* Google */}
                            <a href="">
                                <i className="fa-brands fa-google" style={{ color: "#4285F4", fontSize: "24px", margin: "0 10px" }}></i>
                            </a>
                        </div>

                    </section>

                    <section className="">
                        <div className="container text-center text-md-start mt-5">
                            {/* <!-- Grid row --> */}
                            <div className="row mt-3">
                                {/* <!-- Grid column --> */}
                                <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                                    {/* <!-- Content --> */}
                                    <h6 className="text-uppercase fw-bold mb-4">
                                        <i className="fas fa-gem me-3"></i>Balloon Decoration
                                    </h6>
                                    <p>
                                        we specialize in creating breathtaking balloon decorations that turn ordinary spaces into extraordinary experiences. Whether it's a birthday, wedding, baby shower, corporate event, or any special occasion, our creative and customized balloon designs bring joy, elegance, and a touch of magic to every celebration.
                                    </p>
                                </div>
                                {/* <!-- Grid column --> */}

                                {/* <!-- Grid column --> */}
                                <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                                    {/* <!-- Links --> */}
                                    <h6 className="text-uppercase fw-bold mb-4">
                                        Services
                                    </h6>
                                    <p>
                                        <a href="/gallery" className="text-reset">Birthday Party</a>
                                    </p>
                                    <p>
                                        <a href="/gallery" className="text-reset">Theme Party</a>
                                    </p>
                                    <p>
                                        <a href="/gallery" className="text-reset">Baby Shower</a>
                                    </p>
                                    <p>
                                        <a href="/gallery" className="text-reset">Wedding Planner</a>
                                    </p>
                                    <p>
                                        <a href="/gallery" className="text-reset">Haldi, Mehndi Ceremony</a>
                                    </p>
                                    <p>
                                        <a href="/gallery" className="text-reset">Party & Many More...</a>
                                    </p>
                                </div>
                                {/* <!-- Grid column --> */}

                                {/* <!-- Grid column --> */}
                                <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4" role="navigation">
                                    {/* <!-- Links --> */}
                                    <h6 className="text-uppercase fw-bold mb-4">Useful Links</h6>

                                    <p>
                                        <a href="/about" className="text-reset" rel="noopener noreferrer">About Us</a>
                                    </p>
                                    <p>
                                        <a href="/contact" className="text-reset" rel="noopener noreferrer">Contact Us</a>
                                    </p>
                                    <p>
                                        <a href="/gallery" className="text-reset" rel="noopener noreferrer">Gallery</a>
                                    </p>
                                </div>

                                {/* <!-- Grid column --> */}

                                {/* <!-- Grid column --> */}
                                <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                                    {/* <!-- Links --> */}
                                    <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                                    <p><i className="fas fa-home me-3"></i> Fun 4 U Events, Shivpragati Soc., Hanuman Nagar, Akurli Road, Kandivali(East), Mumbai-400101.</p>
                                    <p>
                                        <i className="fas fa-envelope me-3"></i>
                                        fun4uevents123@gmail.com
                                    </p>
                                    <p><i className="fas fa-phone me-3"></i>+91 9820473034</p>
                                    <p className='fw-bold' style={{ fontSize: "20px" }}>www.<span style={{ color: "rgb(216, 37, 2)" }}>balloon</span>decoration<span style={{ color: "rgb(216, 37, 2)" }}>near</span>me.<span style={{ color: "rgb(216, 37, 2)" }}>com</span></p>
                                    {/* <p><i className="fas fa-print me-3"></i> + 01 234 567 89</p> */}
                                </div>
                                {/* <!-- Grid column --> */}
                            </div>
                            {/* <!-- Grid row --> */}
                        </div>
                    </section>
                    {/* <!-- Section: Links  --> */}

                    {/* <!-- Copyright --> */}
                    <div className="text-center p-4" style={{ backgroundColor: "rgba(0,0,0, 0.5)" }}>
                        © 2025 Copyright:
                        <a className="text-reset fw-bold" href="https://www.kumarinfotech.net/">Kumarinfotech</a>
                    </div>
                    {/* <!-- Copyright --> */}
                </footer>
            </section>
        </>
    )
}

export default Footer;